module.exports = {"pt-BR":{"map":{"cooperatives_list":"Lista de associações"}}}